import { Tooltip } from "@material-ui/core"
import LocalLibraryOutlinedIcon from '@material-ui/icons/LocalLibraryOutlined'
import { WrappedComponentProps } from "react-intl"

import { useMemo } from "react"
import '../ReportsItem.scss'

export type ReadReceiptsIndicatorProps = {
    readReceipts: { userId: number, userNameAndSurName: string, time: Date }[]
} & WrappedComponentProps

const ReadReceiptsIndicator = ({ readReceipts, intl }: ReadReceiptsIndicatorProps) => {
     const earliestReceiptPerUser = useMemo(() => readReceipts.reduce((acc, item) => {
        if (!acc.has(item.userId) || acc.get(item.userId)?.time > item.time) {
            acc.set(item.userId, { userId: item.userId, time: item.time, name: item.userNameAndSurName });
        }
        return acc;
    }, new Map<number, { userId: number, time: Date, name: string }>()), [readReceipts])

    return <div className='ReportsItems__ReadReceipt' >
        <Tooltip arrow placement='top' title={
            <ul className='ReportsItems__ReadReceipt--list'>
                {earliestReceiptPerUser.size && Array.from(earliestReceiptPerUser.values()).map((item) => {
                    return <li key={item.userId}>{`${item.name}: ${intl.formatDate(item.time)}`}</li>
                })}
            </ul>
        }><LocalLibraryOutlinedIcon /></Tooltip>
    </div>
}

export default ReadReceiptsIndicator